import React, {useState, useEffect} from "react"
import Typing from 'react-typing-animation'

import Layout from "../components/layout"
import SEO from "../components/seo"

import TextBorder from "../components/TextBorder"
import CharacterSpin from "../components/CharacterSpin"

const IndexPage = () => {

let [loaded, setLoaded] = useState(false)

// useEffect(()=>{
// if (typeof window !== `undefined`) {

//   window.location.replace("https://www.spitfireaudio.com/shop/a-z/darkstar-haunted-house/");
  
// }
// })


return (
  <Layout>
    <SEO title="Boo" />
    <div className="formPage">
      {
      !loaded && <div className="loadingAnimation" >
          <div className="dialingUpHangOn">
            <p className="dialinUp">.... DiALiN . UP..</p>
            <p className="hangOn">..hang . on!</p>
          </div>

        <Typing speed={1} hideCursor={true} className="exes" onFinishedTyping={() => setLoaded(true)}>
          <Typing.Delay ms={500} />
          <p>xxxxxxxxx<Typing.Delay ms={600} />xxxxxxxxxxxxxx<Typing.Delay ms={1200} />xxxxxxxxxxxxxx<Typing.Delay ms={400} />xx</p>
        </Typing>
      </div>
      }


    {/* { loaded && <h1 className="boologo">Boo</h1> } */}

      {
      loaded &&
        <div className="signUpForm" >
          <p>S<CharacterSpin>i</CharacterSpin>GN UP FOR UPDAT<CharacterSpin>E</CharacterSpin>S</p>
          <form name="contact" method="POST" data-netlify="true" netlify-honeypot="bot-field" action="/success" >
            <input type="hidden" name="form-name" value="contact" />
            <div className="textBoxHolder">
              <input type="email" placeholder="email address" name="email" required />
            </div>
            <input type="submit" value="Submit"/>
          </form>
        </div>
      }

      { loaded && <TextBorder />}

    </div>

  </Layout>
)
}

export default IndexPage
